var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "adminNav", attrs: { id: "topNav" } },
    [
      _c(
        "router-link",
        { staticClass: "systemName", attrs: { to: { name: "adminHome" } } },
        [_vm._v(_vm._s(_vm.systemName) + " Admin")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "adminSettings",
          attrs: { to: { name: "adminSettings" } }
        },
        [_vm._v("Settings")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { staticClass: "adminUsers", attrs: { to: { name: "adminUsers" } } },
        [_vm._v("Users")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "adminProjects",
          attrs: { to: { name: "adminProjects" } }
        },
        [_vm._v("Projects")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { staticClass: "adminMcp", attrs: { to: { name: "adminMcp" } } },
        [_vm._v("MCP")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        { staticClass: "clientHome", attrs: { to: { name: "clientHome" } } },
        [_vm._v("Client")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "logoutButton",
          attrs: { role: "button" },
          on: { click: _vm.logoutClicked }
        },
        [_vm._v("Log Out")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }